export type EstadoDeVigencia = 'vigente' | 'por-caducar' | 'caducado';

const DIA = 24 * 60 * 60 * 1000;

export function diasRestantes(validoHasta: string, ahora: Date = new Date()): number {
  return Math.floor((new Date(validoHasta).getTime() - ahora.getTime()) / DIA);
}

export function estadoDeVigencia(validoHasta: string, ahora: Date = new Date()): EstadoDeVigencia {
  const dias = diasRestantes(validoHasta, ahora);
  if (new Date(validoHasta).getTime() < ahora.getTime()) {
    return 'caducado';
  }
  return dias <= 30 ? 'por-caducar' : 'vigente';
}

export function consumido(
  validoDesde: string,
  validoHasta: string,
  ahora: Date = new Date(),
): number {
  const inicio = new Date(validoDesde).getTime();
  const fin = new Date(validoHasta).getTime();
  if (fin <= inicio) {
    return 100;
  }
  return Math.min(100, Math.max(0, ((ahora.getTime() - inicio) / (fin - inicio)) * 100));
}

export function enFecha(instante: string): string {
  return new Date(instante).toLocaleDateString('es-EC', {
    timeZone: 'America/Guayaquil',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function areaEnPorcentaje(m: {
  superior: number;
  inferior: number;
  izquierdo: number;
  derecho: number;
}): { top: string; bottom: string; left: string; right: string } {
  return {
    top: `${(m.superior / 297) * 100}%`,
    bottom: `${(m.inferior / 297) * 100}%`,
    left: `${(m.izquierdo / 210) * 100}%`,
    right: `${(m.derecho / 210) * 100}%`,
  };
}
